import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  FLAG_GETTING_BILLINGS,
  GET_BILLINGS,
  CLEAR_BILLINGS,
  FLAG_BILLING_ACTIVITY,
  GET_BILLING,
  CLEAR_BILLING,
} from '../../../actions/types/accounting';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_BILLINGS:
      return state.setIn(['all', 'loading'], payload);
    case GET_BILLINGS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_BILLINGS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_BILLING_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_BILLING:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_BILLING:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
